export const TOGGLES = {
  MAINTENANCE_ENABLED: "MAINTENANCE_ENABLED",
  PENSION_ANNUITY_IMPORT_QUOTE_ENABLED: "PENSION_ANNUITY_IMPORT_QUOTE_ENABLED",
  PENSION_ANNUITY_HIGHLIGHT_CHANGES_ENABLED: "PENSION_ANNUITY_HIGHLIGHT_CHANGES_ENABLED",
  PENSION_ANNUITY_API_SUPPORTS_DIFFERENT_OPTIONS: "PENSION_ANNUITY_API_SUPPORTS_DIFFERENT_OPTIONS",
  PENSION_ANNUITY_CASE_TRACKING_ENABLED: "PENSION_ANNUITY_CASE_TRACKING_ENABLED"
};

export default TOGGLES;
